import { render, staticRenderFns } from "./GroupExplain.vue?vue&type=template&id=42221105&scoped=true&"
import script from "./GroupExplain.vue?vue&type=script&lang=js&"
export * from "./GroupExplain.vue?vue&type=script&lang=js&"
import style0 from "./GroupExplain.vue?vue&type=style&index=0&id=42221105&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42221105",
  null
  
)

export default component.exports